import React, { useState, useEffect } from "react";
import axios from "../../../util/axios";
import { useParams } from "react-router-dom";
import '../../../styles/_3dmodel.css'
import IframeViewer from "./IframeViewer";
import LoadingBox from "../../ui/loading-box/components/loading-box";
function YourSmilePlan() {
  let { id } = useParams();
  const [planId, setPlanId] = useState(null);
  const [models, setModels] = useState(null);
  const [modelsZipUrls, setModelsZipUrls] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(async () => {
    const ac = new AbortController();
    try {
      setLoading(true);
      const result = await axios.get(
        "admin/v1/users/" + id + "/smile-plan/preferred",
      );
      const data = result.data.data;
      setPlanId(data.id);

      if (data.three_dimension_smile_url?.length) {
        setModels(data.three_dimension_smile_url);
      } else if (data.models_zip_urls) {
        setModelsZipUrls(data.models_zip_urls);
      }
    } catch (err) {
      console.log("error=", err);
    } finally {
      setLoading(false);
    }
    return () => ac.abort();
  }, []);

  if (loading || !planId) {
    return <LoadingBox />
  }
  
  return (
    <div className="model3d">
      <IframeViewer
        planId={planId}
        models={models}
        modelsZipUrls={modelsZipUrls}
      />
    </div>
  );
}
export default React.memo(YourSmilePlan);
